/**
 * Flyout title for the Adequacy Access Point Profile. It lives here rather than on the component so that
 * consumers which mock ServicingProviderProfile in tests still resolve a real title.
 */
export const ACCESS_POINT_PROFILE_FLYOUT_TITLE = "Access Point Profile";
